<template>
  <div>
    <info-modal ref="infoModal" @ok-submit="closeModal" :msg="infoMsg">
    </info-modal>
    <liff-error-modal
      ref="errorModal"
      @ok-submit="closeModal"
      :msg="errorMsg"
    />
    <div class="bg-leave-liff">
      <div class="header-text">
        <div>
          {{ $vuetify.lang.t("$vuetify.checkInOutLater.checkInOutLater") }}
        </div>
        <span class="lang mr-3">
          <change-lang />
        </span>
      </div>
      <v-form ref="form" class="form-container" lazy-validation>
        <div>
          <span class="label-tag">
            {{ $vuetify.lang.t("$vuetify.checkInOutLater.forgetDate") }}
          </span>
          <v-menu
            v-model="datePickerStartDateShow"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFormattedStartDate"
                prepend-inner-icon="event"
                @click:prepend="datePickerStartDateShow = true"
                :rules="inputRules"
                :error-messages="errors.date"
                solo
                height="40px"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :locale="localeLang"
              v-model="form.date"
              @input="datePickerStartDateShow = false"
              :min="minDate"
              :max="maxDate"
            >
            </v-date-picker>
          </v-menu>
        </div>
        <div>
          <span class="label-tag">
            {{ $vuetify.lang.t("$vuetify.checkInOutLater.request") }}
          </span>
          <v-select
            v-model="form.requestType"
            :items="requestType"
            :rules="inputRules"
            :error-messages="errors.requestType"
            @change="requestChange"
            solo
            height="40px"
            :placeholder="$vuetify.lang.t('$vuetify.checkInOutLater.selectType')"
            item-text="text"
            item-value="value"
          >
          </v-select>
        </div>
        <div v-if="clientOs === 'ios'" :class="{ 'd-flex justify-space-between': isCheckInOut }">
            <div v-if="form.requestType" class="full-width mr-3">
                  <span class="label-tag">
                    {{ $vuetify.lang.t(this.isCheckIn ? "$vuetify.checkInOutLater.checkInTime" : "$vuetify.checkInOutLater.checkOutTime") }}
                  </span>
                  <v-text-field
                    ref="checkInTime"
                    v-model="selectedRequestType"
                    type="time"
                    solo
                    height="40px"
                    :rules="timeRules"
                    :placeholder="$vuetify.lang.t('$vuetify.checkInOutLater.selectTime')"
                  >
                  </v-text-field>
            </div>
            <div v-if="isCheckInOut" class="full-width">
                  <span class="label-tag">
                    {{ $vuetify.lang.t("$vuetify.checkInOutLater.checkOutTime") }}
                  </span>
                  <v-text-field
                    ref="checkOutTime"
                    v-model="form.checkOutTime"
                    type="time"
                    solo
                    height="40px"
                    :rules="timeRules"
                    :placeholder="$vuetify.lang.t('$vuetify.checkInOutLater.selectTime')"
                  >
                  </v-text-field>
            </div>
        </div>
        <div v-else :class="{ 'd-flex justify-space-between': isCheckInOut }">
              <div v-if="form.requestType" :class="{ 'mr-3': isCheckInOut }">
                <span class="label-tag">
                  {{ $vuetify.lang.t(this.isCheckIn ? "$vuetify.checkInOutLater.checkInTime" : "$vuetify.checkInOutLater.checkOutTime") }}
                </span>
                <vue-timepicker
                  ref="checkInTime"
                  :key="isCheckIn"
                  v-model="selectedRequestType"
                  hide-clear-button
                  auto-scroll
                  hour-label="Hour"
                  minute-label="Minute"
                  @close="closeDropdownTimeAndroid(selectedRequestType, isCheckIn ? firstCheck : secondCheck)"
                  @change="changeSelectedTime"
                  :placeholder="$vuetify.lang.t('$vuetify.checkInOutLater.selectTime')"
                >
                </vue-timepicker>
                <div class="margin-bottom"><span v-if="isCheckIn ? chechInTimeError : chechOutTimeError" class="validate-time">{{ isCheckIn ? chechInTimeError : chechOutTimeError }}</span></div>
              </div>
              <div v-if="isCheckInOut">
                <span class="label-tag">
                  {{ $vuetify.lang.t("$vuetify.checkInOutLater.checkOutTime") }}
                </span>
                <vue-timepicker
                  ref="checkOutTime"
                  :key="isCheckInOut"
                  v-model="form.checkOutTime"
                  hide-clear-button
                  auto-scroll
                  hour-label="Hour"
                  minute-label="Minute"
                  @close="closeDropdownTimeAndroid(form.checkOutTime, secondCheck)"
                  @change="changeSelectedTime"
                  :placeholder="$vuetify.lang.t('$vuetify.checkInOutLater.selectTime')">
                </vue-timepicker>
                <div class="margin-bottom"><span v-if="chechOutTimeError" class="validate-time">{{ chechOutTimeError }}</span></div>
              </div>
        </div>
        <div>
          <span class="label-tag">
            {{ $vuetify.lang.t("$vuetify.checkInOutLater.reason") }}
          </span>
          <v-textarea
            label="Reason"
            :placeholder="$vuetify.lang.t('$vuetify.checkInOutLater.reasonMsg')"
            v-model="form.description"
            counter
            no-resize
            solo
            height="90px"
            :rules="descriptionRules"
            :maxlength="255"
          >
          </v-textarea>
        </div>
        <div class="flex-center">
          <v-btn class="margin-rigth" @click="closeWindow">
            {{ $vuetify.lang.t("$vuetify.liff.cancel") }}
          </v-btn>
          <v-btn color="primary" :disabled="!lineUserId" @click="submitForm">
            {{ $vuetify.lang.t("$vuetify.liff.submit") }}
          </v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import InfoModal from '@/components/modal/InfoModal'
import ChangeLang from '@/components/liff/ChangeLang'
import LiffErrorModal from '@/components/modal/LiffErrorModal'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
    name: 'CheckInOutLater',

    components: {
        InfoModal,
        ChangeLang,
        LiffErrorModal,
        VueTimepicker
    },

    data () {
        return {
            clientOs: null,
            chechInTimeError: null,
            chechOutTimeError: null,
            firstCheck: 'CheckIn',
            secondCheck: 'CheckOut',
            form: {
                date: this.$util.getCurrentDate(),
                requestType: null,
                checkInTime: null,
                checkOutTime: null,
                description: null
            },
            timeRules: [
                (v) => this.$validator.hasValue(v, this.$vuetify.lang.t('$vuetify.checkInOutLater.fieldRequired')),
                (v) => {
                    if (this.form.checkInTime !== '' && this.form.checkOutTime !== '') {
                        if (moment(this.form.checkInTime, 'HH:mm').isBefore(moment(this.form.checkOutTime, 'HH:mm'))) return true
                        else return this.$vuetify.lang.t('$vuetify.checkInOutLater.invalidTime')
                    }
                    return true
                }
            ],
            inputRules: [
                (v) => this.$validator.hasValue(v, this.$vuetify.lang.t('$vuetify.checkInOutLater.fieldRequired'))
            ],
            descriptionRules: [
                (v) => this.$validator.hasValue(v, this.$vuetify.lang.t('$vuetify.checkInOutLater.fieldRequired')),
                (v) => this.$validator.lengthNotExceed(v, 255, this.$vuetify.lang.t('$vuetify.checkInOutLater.fieldLessThanCharacters'))
            ],
            lineUserId: null,
            requestType: [],
            datePickerStartDateShow: false,
            datePickerEndDateShow: false,
            dateFormattedStartDate: this.$util.formatDate(this.$util.getCurrentDate()),
            dateFormattedEndDate: this.$util.formatDate(this.$util.getCurrentDate()),
            isCheckIn: true,
            isCheckInOut: false,
            infoMsg: null,
            errorMsg: '',
            errors: []
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },

        selectedRequestType: {
            get () {
                return this.isCheckIn ? this.form.checkInTime : this.form.checkOutTime
            },
            set (value) {
                this.isCheckIn
                    ? (this.form.checkInTime = value)
                    : (this.form.checkOutTime = value)
            }
        },

        minDate () {
            const sevenDaysAgo = new Date()
            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 6)
            return sevenDaysAgo.toISOString().slice(0, 10)
        },

        maxDate () {
            const currentDay = new Date()
            currentDay.setDate(currentDay.getDate() + 1)
            return currentDay.toISOString().slice(0, 10)
        },

        isValid () {
            if (this.form.checkInTime !== '' && this.form.checkOutTime !== '') {
                if (moment(this.form.checkInTime, 'HH:mm').isBefore(moment(this.form.checkOutTime, 'HH:mm'))) return true
                else return false
            } else if (this.form.checkInTime !== '') return true
            else if (this.form.checkOutTime !== '') return true
            else return false
        }
    },

    methods: {
        requestChange () {
            this.clearForm()
            if (this.form.requestType === 'In' || this.form.requestType === 'เข้า') {
                this.isCheckIn = true
                this.isCheckInOut = false
            } else if (this.form.requestType === 'Out' || this.form.requestType === 'ออก') {
                this.isCheckIn = false
                this.isCheckInOut = false
            } else if (this.form.requestType === 'In - Out' || this.form.requestType === 'เข้า - ออก') {
                this.isCheckIn = true
                this.isCheckInOut = true
            }
        },

        closeDropdownTimeAndroid (time, checkStatus) {
            const [hours, minutes] = time.split(':')

            if (checkStatus === this.firstCheck) {
                if (hours === 'HH' && minutes === 'mm') {
                    this.form.checkInTime = '00.00'
                } else if (hours === 'HH') {
                    this.form.checkInTime = '00:' + minutes
                } else if (minutes === 'mm') {
                    this.form.checkInTime = hours + ':00'
                }
            } else if (checkStatus === this.secondCheck) {
                if (hours === 'HH' && minutes === 'mm') {
                    this.form.checkOutTime = '00.00'
                } else if (hours === 'HH') {
                    this.form.checkOutTime = '00:' + minutes
                } else if (minutes === 'mm') {
                    this.form.checkOutTime = hours + ':00'
                }
            }
        },

        changeSelectedTime () {
            if (this.form.checkInTime !== '' && this.form.checkOutTime !== '') {
                if (moment(this.form.checkInTime, 'HH:mm').isBefore(moment(this.form.checkOutTime, 'HH:mm'))) {
                    this.chechInTimeError = null
                    this.chechOutTimeError = null
                } else {
                    this.chechInTimeError = this.$vuetify.lang.t('$vuetify.checkInOutLater.invalidTime')
                    this.chechOutTimeError = this.$vuetify.lang.t('$vuetify.checkInOutLater.invalidTime')
                }
            } else if (this.form.checkInTime !== '') {
                if (this.isCheckIn) this.chechInTimeError = null
                else this.chechOutTimeError = null
            } else if (this.form.checkOutTime !== '') {
                if (this.isCheckIn) this.chechInTimeError = null
                else this.chechOutTimeError = null
            } else {
                if (this.isCheckIn) this.chechInTimeError = this.$vuetify.lang.t('$vuetify.checkInOutLater.fieldRequired')
                else this.chechOutTimeError = this.$vuetify.lang.t('$vuetify.checkInOutLater.fieldRequired')
            }
        },

        errorAlert (message) {
            this.$store.dispatch('setLoading', false)
            this.$refs.errorModal.dialog = true
            this.errorMsg = message
        },

        clearForm () {
            this.selectedRequestType = null
            this.form.checkInTime = ''
            this.form.checkOutTime = ''
            this.form.description = ''
            this.errors = {}
            this.$refs.form.resetValidation()
            this.dialog = false
        },

        closeWindow () {
            this.$liff.closeWindow()
        },

        closeModal () {
            this.closeWindow()
        },

        async submitForm () {
            this.chechInTimeError = null
            this.chechOutTimeError = null
            if (!this.$refs.form.validate()) {
                return
            }

            if (!this.isValid) {
                this.chechInTimeError = this.$vuetify.lang.t('$vuetify.checkInOutLater.fieldRequired')
                this.chechOutTimeError = this.$vuetify.lang.t('$vuetify.checkInOutLater.fieldRequired')
            }

            this.$store.dispatch('setLoading', true)

            const { date, checkInTime, checkOutTime, description } = this.form
            const submitForm = {
                lineId: this.lineUserId,
                requestNo: Date.now().toString(32).toUpperCase(),
                requestDate: date,
                description: description
            }

            if (this.form.requestType === 'เข้า' || this.form.requestType === 'In') {
                submitForm.requestType = 'MRN'
                submitForm.startTime = checkInTime
                submitForm.endTime = null
            } else if (this.form.requestType === 'ออก' || this.form.requestType === 'Out') {
                submitForm.requestType = 'ATN'
                submitForm.startTime = null
                submitForm.endTime = checkOutTime
            } else if (this.form.requestType === 'เข้า - ออก' || this.form.requestType === 'In - Out') {
                submitForm.requestType = 'FUL'
                submitForm.startTime = checkInTime
                submitForm.endTime = checkOutTime
            }

            const res = await axios.post(`${process.env.VUE_APP_BACKEND}/attendance-request/create`, submitForm)
            if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
            } else if (res && res.data && res.data.status === 'ok') {
                this.$refs.infoModal.dialog = true
            } else {
                this.errorAlert(res.data.msg)
            }
            this.$store.dispatch('setLoading', false)
        }
    },

    async mounted () {
        this.requestType = this.$vuetify.lang.current === 'en' ? ['Out', 'In - Out'] : ['ออก', 'เข้า - ออก']
        this.clientOs = this.$util.getLineOs()
        this.$store.dispatch('setLoading', true)
        try {
            this.lineUserId = await this.$util.getLineIdForLiff(process.env.VUE_APP_LINE_ATTEN_REQUEST_URL)
            // this.lineUserId = 'U911d4ef1b4ce16c7a361477803c7f35f'
        } catch (error) {
            this.errorAlert(
                this.$vuetify.lang.t('$vuetify.checkInOutLater.cannotGetLineId')
            )
        }
        this.$store.dispatch('setLoading', false)
    },

    watch: {
        'form.date' () {
            this.dateFormattedStartDate = this.$util.formatDate(this.form.date)
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                this.$util.recheckValidate(this.$refs.form.inputs)
                this.chechInTimeError = this.$vuetify.lang.t('$vuetify.checkInOutLater.invalidTime')
                this.chechOutTimeError = this.$vuetify.lang.t('$vuetify.checkInOutLater.invalidTime')
                this.isCheckInOut = false
                this.requestType = after === 'en' ? ['Out', 'In - Out'] : ['ออก', 'เข้า - ออก']
                if (after === 'en') {
                    if (this.form.requestType === 'เข้า') this.form.requestType = 'In'
                    else if (this.form.requestType === 'ออก') this.form.requestType = 'Out'
                    else if (this.form.requestType === 'เข้า - ออก') {
                        this.form.requestType = 'In - Out'
                        this.isCheckInOut = true
                    }
                } else {
                    if (this.form.requestType === 'In') this.form.requestType = 'เข้า'
                    else if (this.form.requestType === 'Out') this.form.requestType = 'ออก'
                    else if (this.form.requestType === 'In - Out') {
                        this.form.requestType = 'เข้า - ออก'
                        this.isCheckInOut = true
                    }
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .search-input .v-input__control > .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #a8a8a8 !important;
}

.flex-center {
  display: flex;
  justify-content: center;
  height: 40px;
}

.margin-rigth {
  margin-right: 16px;
}

.file-lao {
  display: none;
}

.bg-leave-liff {
  background-color: #2e2929;
  color: #ffffff;
  height: 100vh;

  .header-text {
    font-family: LexendDeca;
    font-size: 20px;
    padding: 1rem;
    height: 10%;
    min-height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .form-container {
    background: #ffffff;
    border-top-right-radius: 30px;
    border-top-left-radius: 30px;
    padding: 2rem;
    color: #6c6c6c;
    font-size: 14px;
    font-weight: normal;
    overflow: scroll;
    height: 90%;
  }

  .label-tag {
    font-size: 12px;
    color: #757575;
  }
}

.lang {
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 18px;
  &-th {
    font-family: Prompt;
  }
  &-en {
    font-family: LexendDeca;
  }
}

.text-underline {
  text-decoration: underline;
  color: #d76436;
}

.full-width {
  width: 100%;
}

.margin-bottom {
   margin-bottom: 10%;
}

.validate-time {
  margin: 8px 8px;
  font-size: 12px;
  color: #ff5733;
}

</style>
